// /* eslint-disable eslint-comments/disable-enable-pair */
// /* eslint-disable no-unused-vars */
// /* eslint-disable no-console */
// /* eslint-disable no-alert */
// /* eslint-disable no-undef */
// /* eslint-disable no-var */
// /* eslint-disable prettier/prettier */
// /* eslint-disable object-shorthand */
// /**
//  * File map.js
//  *
//  * Deal with map display.
//  */

// // eslint-disable-next-line no-unused-expressions
// ((g) => {
//   var h,
//     a,
//     k,
//     p = "The Google Maps JavaScript API",
//     c = "google",
//     l = "importLibrary",
//     q = "__ib__",
//     m = document,
//     b = window;
//   b = b[c] || (b[c] = {});
//   var d = b.maps || (b.maps = {}),
//     r = new Set(),
//     e = new URLSearchParams(),
//     u = () =>
//       h ||
//       (h = new Promise(async (f, n) => {
//         await (a = m.createElement("script"));
//         r.add("geometry");
//         e.set("libraries", [...r] + "");
//         for (k in g)
//           e.set(
//             k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
//             g[k],
//           );
//         e.set("callback", c + ".maps." + q);
//         a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
//         d[q] = f;
//         a.onerror = () => (h = n(Error(p + " could not load.")));
//         a.nonce = m.querySelector("script[nonce]")?.nonce || "";
//         m.head.append(a);
//       }));
//   // eslint-disable-next-line no-unused-expressions
//   d[l]
//     ? console.warn(p + " only loads once. Ignoring:", g)
//     : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
// })({
//   key: "AIzaSyCG-kqGRisWY0i6nQITmPed38hVmyJfRH4",
//   v: "weekly",
// });

// let map;
// let bigMap;
// let markersArray = [];

// async function initMap() {
//   const position = { lat: latitude, lng: longitude };
//   const { Map } = await google.maps.importLibrary("maps");
//   const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

//   map = new Map(document.getElementById("location-map"), {
//     zoom: 12,
//     center: position,
//     mapId: "89ad72c95c1a3475",
//   });

//   const markerDiv = document.createElement("div");
//   markerDiv.style.width = "30px";
//   markerDiv.style.height = "35px";
//   markerDiv.style.backgroundImage =
//     "url(/wp-content/themes/CommunityBank_V2/assets/images/icons/pin.svg)";
//   markerDiv.style.backgroundRepeat = "no-repeat";
//   markerDiv.style.backgroundSize = "contain";
//   markerDiv.style.backgroundPosition = "center";
//   markerDiv.style.display = "flex";
//   markerDiv.style.alignItems = "center";
//   markerDiv.style.justifyContent = "center";
//   markerDiv.style.color = "white";
//   markerDiv.style.fontSize = "14px";
//   markerDiv.style.fontWeight = "bold";

//   const marker = new AdvancedMarkerElement({
//     map: map,
//     position: position,
//     content: markerDiv,
//   });
// }

// initMap();

// async function initializeGoogleMap() {
//   const { Map } = await google.maps.importLibrary("maps");
//   const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

//   const mapCenter =
//     locations.length > 0
//       ? {
//           lat: parseFloat(locations[0].lat),
//           lng: parseFloat(locations[0].lng),
//         }
//       : { lat: 0, lng: 0 };

//   bigMap = new Map(document.getElementById("location-big-map"), {
//     zoom: 12,
//     center: mapCenter,
//     mapId: "89ad72c95c1a3475",
//   });

//   locations.forEach((location, index) => {
//     const position = {
//       lat: parseFloat(location.lat),
//       lng: parseFloat(location.lng),
//     };

//     const markerDiv = document.createElement("div");
//     markerDiv.style.width = "30px";
//     markerDiv.style.height = "35px";
//     markerDiv.style.backgroundImage =
//       "url(/wp-content/themes/CommunityBank_V2/assets/images/icons/pin.svg)";
//     markerDiv.style.backgroundRepeat = "no-repeat";
//     markerDiv.style.backgroundSize = "contain";
//     markerDiv.style.backgroundPosition = "center";
//     markerDiv.style.display = "flex";
//     markerDiv.style.alignItems = "center";
//     markerDiv.style.justifyContent = "center";
//     markerDiv.style.color = "white";
//     markerDiv.style.fontSize = "14px";
//     markerDiv.style.fontWeight = "bold";
//     markerDiv.textContent = (index + 1).toString();

//     const marker = new AdvancedMarkerElement({
//       map: bigMap,
//       position: position,
//       title: location.title,
//       content: markerDiv,
//     });

//     markersArray.push(marker);
//   });
// }

// initializeGoogleMap();

// function clearMarkers() {
//   if (markersArray.length > 0) {
//     markersArray.forEach((marker) => marker.setMap(null));
//     markersArray = [];
//   }
// }

// document.getElementById("search-btn").addEventListener("click", function () {
//   const zipCode = document.getElementById("zip-search").value;

//   jQuery.ajax({
//     url: map_ajax_params.ajax_url,
//     method: "POST",
//     data: {
//       action: "search_locations_by_zip",
//       zip_code: zipCode,
//     },
//     success: function (response) {
//       if (response.success && response.data.length > 0) {
//         updateLocationResults(response.data);
//         resetMap(response.data);
//       } else {
//         alert("No locations found for the entered ZIP code.");
//         clearMarkers();
//       }
//     },
//     error: function (xhr, status, error) {
//       console.error("AJAX Error:", error);
//     },
//   });
// });

// function updateLocationResults(locations) {
//   const resultsContainer = document.querySelector(".location-results");
//   resultsContainer.innerHTML = "";

//   function convertTo24Hour(timeStr) {
//     const [time, modifier] = timeStr.split(" ");
//     let [hours, minutes] = time.split(":");

//     if (hours === "12") {
//       hours = "00";
//     }
//     if (modifier.toLowerCase() === "pm") {
//       hours = parseInt(hours, 10) + 12;
//     }

//     return `${hours.toString().padStart(2, "0")}:${minutes}`;
//   }

//   locations.forEach(function (location, index) {
//     const currentTime = new Date();
//     const timeNow =
//       currentTime.getHours().toString().padStart(2, "0") +
//       ":" +
//       currentTime.getMinutes().toString().padStart(2, "0");

//     let officeStatus = "Office Closed";
//     if (
//       location.open_hours &&
//       location.open_hours.in &&
//       location.open_hours.out
//     ) {
//       const openTime24 = convertTo24Hour(location.open_hours.in);
//       const closeTime24 = convertTo24Hour(location.open_hours.out);
//       const openTime = new Date(`1970-01-01T${openTime24}:00`);
//       const closeTime = new Date(`1970-01-01T${closeTime24}:00`);
//       const currentTimeParsed = new Date(`1970-01-01T${timeNow}:00`);

//       console.log(
//         `Comparing times for ${location.title}: openTime = ${openTime}, closeTime = ${closeTime}, currentTime = ${currentTimeParsed}`,
//       );

//       if (currentTimeParsed >= openTime && currentTimeParsed <= closeTime) {
//         officeStatus = "Open Now";
//       } else {
//         officeStatus = "Office Closed";
//       }
//     }

//     const locationItem = `
//             <div class="location-item">
//                 <div class="counter-pin">${index + 1}</div>
//                 <div class="information">
//                     <h2>${location.title}</h2>
//                     <p class="location-address">${location.address}</p>
//                     <h4 class="open-now">${officeStatus} <img src="/clock" alt=""></h4>
//                     <div class="contact">
//                         <a href="tel:${location.phone}">${location.phone}</a>
//                         <a href="${
//                           location.directions
//                         }" target="_blank">Directions</a>
//                         <a href="${location.permalink}">View Details</a>
//                     </div>
//                 </div>
//             </div>
//         `;
//     resultsContainer.insertAdjacentHTML("beforeend", locationItem);
//   });
// }

// function updateMapMarkers(locations) {
//   locations.forEach(function (location, index) {
//     const position = {
//       lat: parseFloat(location.lat),
//       lng: parseFloat(location.lng),
//     };

//     const markerDiv = document.createElement("div");
//     markerDiv.style.width = "30px";
//     markerDiv.style.height = "35px";
//     markerDiv.style.backgroundImage =
//       "url(/wp-content/themes/CommunityBank_V2/assets/images/icons/pin.svg)";
//     markerDiv.style.backgroundRepeat = "no-repeat";
//     markerDiv.style.backgroundSize = "contain";
//     markerDiv.style.backgroundPosition = "center";
//     markerDiv.style.display = "flex";
//     markerDiv.style.alignItems = "center";
//     markerDiv.style.justifyContent = "center";
//     markerDiv.style.color = "white";
//     markerDiv.style.fontSize = "14px";
//     markerDiv.style.fontWeight = "bold";
//     markerDiv.textContent = (index + 1).toString();

//     const marker = new google.maps.marker.AdvancedMarkerElement({
//       map: bigMap,
//       position: position,
//       title: location.title,
//       content: markerDiv,
//     });

//     markersArray.push(marker);
//   });
// }

// function resetMap(locations) {
//   if (locations.length === 0) {
//     console.error("No locations to display on the map.");
//     return;
//   }

//   const mapCenter = {
//     lat: parseFloat(locations[0].lat),
//     lng: parseFloat(locations[0].lng),
//   };

//   clearMarkers();

//   bigMap = new google.maps.Map(document.getElementById("location-big-map"), {
//     zoom: 12,
//     center: mapCenter,
//     mapId: "89ad72c95c1a3475",
//   });

//   updateMapMarkers(locations);
// }
